import { render, staticRenderFns } from "./MovimentMain.vue?vue&type=template&id=e5ea987c&"
import script from "./MovimentMain.vue?vue&type=script&lang=js&"
export * from "./MovimentMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports